import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HelpIcon } from '@dixa/lib-shared-habla';
import { Component } from 'react';
import AceEditor from 'react-ace';
import Spinner from '../../ajax/components/Spinner';
import 'brace/ext/language_tools';
import 'brace/mode/handlebars';
import 'brace/mode/json';
import 'brace/mode/html';
import 'brace/theme/tomorrow';
/** @deprecated Use FieldTemplate in `src/components/fieldTemplate` instead */
class TemplateField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showTemplateContent: this.props.defaultHidden === true ? false : true,
        };
    }
    render() {
        const { name, displayName, previewButton, previewContent, height, hidden, disabled, required, input, meta, showSpinner, className, showHelpIcon, helpIconTitle, helpIconText, onChangeAction, defaultHidden, } = this.props;
        let formGroupClasses = className && typeof className === 'string' ? className : '';
        let validationErrors = null;
        let spinner = null;
        let helpIcon = null;
        if ((meta === null || meta === void 0 ? void 0 : meta.visited) && (meta === null || meta === void 0 ? void 0 : meta.valid)) {
            formGroupClasses += ' has-success';
        }
        else if ((meta === null || meta === void 0 ? void 0 : meta.visited) && (meta === null || meta === void 0 ? void 0 : meta.error)) {
            formGroupClasses += ' has-error';
            validationErrors = _jsx("span", Object.assign({ className: "validation-text" }, { children: meta.error }));
        }
        if (hidden === true) {
            formGroupClasses += ' hidden';
        }
        if (disabled === true) {
            formGroupClasses += ' disabled';
        }
        if (showSpinner === true) {
            spinner = _jsx(Spinner, { className: "dark input" });
        }
        if (showHelpIcon === true) {
            helpIcon = _jsx(HelpIcon, { text: helpIconText, title: helpIconTitle });
        }
        return (_jsxs("div", Object.assign({ className: `form-group ${formGroupClasses}` }, { children: [_jsxs("div", { children: [displayName !== '' && (_jsxs("label", Object.assign({ className: "control-label", htmlFor: name }, { children: [displayName, " ", required === true ? '*' : '', " ", validationErrors] }))), helpIcon, previewButton ? previewButton : null] }), _jsxs("div", { children: [previewContent ? previewContent : null, this.state.showTemplateContent && !previewContent && (_jsx(AceEditor, { onFocus: input.onFocus, mode: "handlebars", theme: "tomorrow", name: "template", onChange: (e) => {
                                if (typeof onChangeAction === 'function') {
                                    onChangeAction(e);
                                }
                                input.onChange(e);
                            }, fontSize: 14, width: "100%", height: height, showPrintMargin: false, showGutter: false, highlightActiveLine: true, value: input.value, setOptions: {
                                enableBasicAutocompletion: true,
                                enableLiveAutocompletion: true,
                                enableSnippets: false,
                                showLineNumbers: true,
                                tabSize: 2,
                            } })), defaultHidden && !this.state.showTemplateContent ? (_jsx("div", { children: _jsxs("span", Object.assign({ style: { marginLeft: 10 } }, { children: ["If you want to customize this template click", ' ', _jsx("a", Object.assign({ style: { cursor: 'pointer' }, onClick: () => this.setState({ showTemplateContent: true }) }, { children: "HERE" }))] })) })) : null, spinner] })] })));
    }
}
TemplateField.defaultProps = {
    height: '250px',
    disabled: false,
    hidden: false,
    required: false,
    className: '',
    showSpinner: false,
    onChangeAction: null,
    placeholder: '',
};
export default TemplateField;
